import { Box, Switch, Typography } from "@mui/material";
import React, { Dispatch } from "react";

interface ISupervisorDashboardProps {
	newAddOnSettings: any;
	setNewAddOnSettings: Dispatch<any>;
}

const SupervisorDashboard: React.FC<ISupervisorDashboardProps> = ({
	newAddOnSettings,
	setNewAddOnSettings,
}) => {
	return (
		<Box
			sx={{
				backgroundColor: "#F5F5F5",
				borderRadius: "8px",
				marginTop: "32px",
				padding: "16px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "16px",
							color: "rgba(0, 0, 0, 0.87)",
						}}
					>
						Supervisor home page
					</Typography>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "12px",
							color: "rgba(0, 0, 0, 0.6)",
						}}
					>
						Show the supervisor home page as the landing page instead of the
						flex schedule.
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Switch
						checked={newAddOnSettings.supervisorDashboardEnabled ?? false}
						onChange={(e) => {
							setNewAddOnSettings((pre: any) => ({
								...pre,
								supervisorDashboardEnabled: e.target.checked,
							}));
						}}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default SupervisorDashboard;
